import { useMutation, useQuery } from "@tanstack/react-query";

import {
  createPackageVersion,
  editPackage,
  fetchPackageDetails,
  fetchPackageVersion,
  fetchServiceUsageDates,
  searchPackages,
} from "clients/packageManagementClient";

export const useSearchPackage = (searchTerm, enabled = false) =>
  useQuery({
    queryKey: ["searchPackages", searchTerm],
    queryFn: () => searchPackages(searchTerm),
    enabled: !!searchTerm && enabled,
  });

export const usePackageDetails = (packageGroupId) =>
  useQuery({
    queryKey: ["packageDetails", packageGroupId],
    queryFn: () => fetchPackageDetails(packageGroupId),
    enabled: true,
  });

export const EXISTING_VERSION_IDS = [
  { key: 1, label: "V1", value: "V1" },
  { key: 2, label: "V2", value: "V2" },
  { key: 3, label: "V3", value: "V3" },
  { key: 4, label: "V4", value: "V4" },
  { key: 5, label: "V5", value: "V5" },
];

export const usePackageVersion = (packageId) =>
  useQuery({
    queryKey: ["packageDetailsByPackageId", packageId],
    queryFn: () => fetchPackageVersion(packageId),
    enabled: !!packageId,
  });

export const useCreatePackageVersion = () =>
  useMutation({ mutationFn: createPackageVersion });

export const useServiceUsageDate = () =>
  useQuery({
    queryKey: ["serviceUsageDate"],
    queryFn: fetchServiceUsageDates,
    enabled: true,
  });

export const useEditPackage = () =>
  useMutation({ mutationFn: editPackage });
